import React from "react";

const DeliveryMap: React.FC = () => {
  return (
    <iframe src="https://yandex.ru/map-widget/v1/?z=12&ol=biz&oid=199762067055"></iframe>
  );
};

export default DeliveryMap;
